import { RelationshipTypeEnum } from '@/types/generated'

export const entitiesDE = {
  [RelationshipTypeEnum.ENTITIES_CLIENT]: 'Mandant',
  [RelationshipTypeEnum.ENTITIES_OPPONENT]: 'Gegner',
  [RelationshipTypeEnum.ENTITIES_OTHER]: 'Sonstige',
  [RelationshipTypeEnum.ENTITIES_LABOR_LAW_EMPLOYEE]: 'Arbeitnehmer',
  [RelationshipTypeEnum.ENTITIES_LABOR_LAW_EMPLOYER]: 'Arbeitgeber',
  [RelationshipTypeEnum.ENTITIES_WITNESS]: 'Zeuge',
  [RelationshipTypeEnum.ENTITIES_AT_FAULT_DRIVER]: 'Unfallverursacher',
  [RelationshipTypeEnum.ENTITIES_VICTIM_DRIVER]: 'Geschädigter Fahrer',
  [RelationshipTypeEnum.ENTITIES_ACCUSED]: 'Beschuldigter',
  [RelationshipTypeEnum.ENTITIES_DEFENDANT]: 'Angeklagter',
  [RelationshipTypeEnum.ENTITIES_PLAINTIFF]: 'Kläger',
  [RelationshipTypeEnum.ENTITIES_COMPLAINT]: 'Beklagter',
  [RelationshipTypeEnum.ENTITIES_VICTIM]: 'Geschädigter',
  [RelationshipTypeEnum.ENTITIES_VEHICLE_EXPERT]: 'KFZ-Sachverständiger',
  [RelationshipTypeEnum.ENTITIES_AGENCY]: 'Behörde',
  [RelationshipTypeEnum.ENTITIES_FOREIGNERS_AUTHORITY]: 'Ausländerbehörde',
  [RelationshipTypeEnum.ENTITIES_VEHICLE_OWNER]: 'Fahrzeughalter',
  [RelationshipTypeEnum.ENTITIES_INSURANCE]: 'Versicherung',
  [RelationshipTypeEnum.ENTITIES_DRIVER]: 'Fahrer',
  [RelationshipTypeEnum.ENTITIES_POLICE_OFFICER]: 'Polizeibeamter',
  [RelationshipTypeEnum.ENTITIES_POLICE_STATION]: 'Polizeidienststelle',
  [RelationshipTypeEnum.ENTITIES_JUDGE]: 'Richter',
  [RelationshipTypeEnum.ENTITIES_COURT]: 'Gericht',
  [RelationshipTypeEnum.ENTITIES_PROSECUTOR]: 'Staatsanwalt',
  [RelationshipTypeEnum.ENTITIES_PUBLIC_PROSECUTOR]: 'Staatsanwaltschaft',
  [RelationshipTypeEnum.ENTITIES_OPPOSING_COUNSEL]: 'Gegnerischer Anwalt',
  [RelationshipTypeEnum.ENTITIES_CO_PLAINTIFF]: 'Nebenkläger',
  [RelationshipTypeEnum.ENTITIES_PROBATION_OFFICER]: 'Bewährungshelfer',
  [RelationshipTypeEnum.ENTITIES_TENANT]: 'Mieter',
  [RelationshipTypeEnum.ENTITIES_LANDLORD]: 'Vermieter',
  [RelationshipTypeEnum.ENTITIES_SUBTENANT]: 'Untermieter',
  [RelationshipTypeEnum.ENTITIES_OWNER]: 'Eigentümer',
  [RelationshipTypeEnum.ENTITIES_PROPERTY_MANAGEMENT]: 'Hausverwaltung',
  [RelationshipTypeEnum.ENTITIES_REAL_ESTATE_AGENT]: 'Immobilienmakler',
  [RelationshipTypeEnum.ENTITIES_GUARANTOR]: 'Bürge',
  [RelationshipTypeEnum.ENTITIES_CO_OWNER]: 'Miteigentümer',
  [RelationshipTypeEnum.ENTITIES_CO_TENANT]: 'Mitmieter',
  [RelationshipTypeEnum.ENTITIES_TENANTS_ASSOCIATION]: 'Mieterverein',
  [RelationshipTypeEnum.ENTITIES_PROPERTY_OWNERS_ASSOCIATION]: 'Eigentümergemeinschaft',
  [RelationshipTypeEnum.ENTITIES_COMPLAINANT]: 'Anzeigenerstatter',
  [RelationshipTypeEnum.ENTITIES_APPLICANT]: 'Antragsteller',
  [RelationshipTypeEnum.ENTITIES_RESPONDENT]: 'Antwortsteller',
  [RelationshipTypeEnum.ENTITIES_PRINCIPAL_CLIENT]: 'Auftraggeber',
  [RelationshipTypeEnum.ENTITIES_CHILD]: 'Kind',
  [RelationshipTypeEnum.ENTITIES_OFFICIANT]: 'Amtsträger',
  [RelationshipTypeEnum.ENTITIES_WIFE]: 'Ehefrau',
  [RelationshipTypeEnum.ENTITIES_HUSBAND]: 'Ehemann',
  [RelationshipTypeEnum.ENTITIES_LEGAL_REPRESENTATIVE]: 'gesetzlicher Vertreter',
  [RelationshipTypeEnum.ENTITIES_KORRESPONDENCE_LAWYER]: 'Korrespondenzanwalt',
  [RelationshipTypeEnum.ENTITIES_OPPOSING_LAWYER]: 'Gegenanwalt',
  [RelationshipTypeEnum.ENTITIES_LAWYER]: 'Anwalt',
  [RelationshipTypeEnum.ENTITIES_LEGAL_EXPENSES_INSURANCE]: 'Rechtsschutzversicherung',
  [RelationshipTypeEnum.ENTITIES_LIABILITY_INSURANCE]: 'Haftpflichtversicherung',
  [RelationshipTypeEnum.ENTITIES_FIRST_INSTANCE_COURT]: 'Gericht 1. Instanz',
  [RelationshipTypeEnum.ENTITIES_SECOND_INSTANCE_COURT]: 'Gericht 2. Instanz',
  [RelationshipTypeEnum.ENTITIES_THIRD_INSTANCE_COURT]: 'Gericht 3. Instanz',
  [RelationshipTypeEnum.ENTITIES_CONTACT_PERSON]: 'Ansprechpartner',
  [RelationshipTypeEnum.ENTITIES_THIRD_PARTY_DEBTOR]: 'Drittschuldner',
  [RelationshipTypeEnum.ENTITIES_ROAD_TRAFFIC_OFFICE]: 'Straßenverkehrsamt',
  [RelationshipTypeEnum.ENTITIES_DEBT_COLLECTION_AGENCY]: 'Inkassounternehmen',
  [RelationshipTypeEnum.ENTITIES_EXPERT]: 'Sachverständiger',
  [RelationshipTypeEnum.ENTITIES_TAX_OFFICE]: 'Finanzamt',
  [RelationshipTypeEnum.ENTITIES_LAND_REGISTRY]: 'Grundbuchamt',
  [RelationshipTypeEnum.ENTITIES_BANK]: 'Bank',
  [RelationshipTypeEnum.ENTITIES_BUYER]: 'Käufer',
  [RelationshipTypeEnum.ENTITIES_DUNNING_COURT]: 'Mahngericht',
  [RelationshipTypeEnum.ENTITIES_ENFORCEMENT_COURT]: 'Vollstreckungsgericht',
  [RelationshipTypeEnum.ENTITIES_GENERAL_PROSECUTOR]: 'Generalstaatsanwaltschaft',
  [RelationshipTypeEnum.ENTITIES_SELLER]: 'Verkäufer',
  [RelationshipTypeEnum.ENTITIES_EXPERT_COMMITTEE]: 'Gutachterausschuss',
  [RelationshipTypeEnum.ENTITIES_MUNICIPALITY]: 'Gemeinde',
  [RelationshipTypeEnum.ENTITIES_ADMINISTRATOR]: 'Verwalter',
  [RelationshipTypeEnum.ENTITIES_REGISTER_COURT]: 'Registergericht',
  [RelationshipTypeEnum.ENTITIES_PROBATE_COURT]: 'Nachlassgericht',
  [RelationshipTypeEnum.ENTITIES_REGISTRY_OFFICE]: 'Standesamt',
  [RelationshipTypeEnum.ENTITIES_HEREDITARY_LEASEHOLDER]: 'Erbbauberechtigter',
  [RelationshipTypeEnum.ENTITIES_LEGAL_AID_COURT]: 'Beratungshilfegericht',
  [RelationshipTypeEnum.ENTITIES_DEBTOR]: 'Schuldner',
  [RelationshipTypeEnum.ENTITIES_CREDITOR]: 'Gläubiger',
  [RelationshipTypeEnum.ENTITIES_LESSEE]: 'Pächter',
  [RelationshipTypeEnum.ENTITIES_LESSOR]: 'Verpächter',
  [RelationshipTypeEnum.ENTITIES_PRINCIPAL]: 'Vollmachtgeber',
  [RelationshipTypeEnum.ENTITIES_AUTHORIZED_REPRESENTATIVE]: 'Bevollmächtigter',
  [RelationshipTypeEnum.ENTITIES_TESTATOR]: 'Erblasser',
  [RelationshipTypeEnum.ENTITIES_HEIR]: 'Erbe',
  [RelationshipTypeEnum.ENTITIES_PRELIMINARY_HEIR]: 'Vorerbe',
  [RelationshipTypeEnum.ENTITIES_SUBSEQUENT_HEIR]: 'Nacherbe',
  [RelationshipTypeEnum.ENTITIES_CURATOR_OF_THE_ESTATE]: 'Nachlasspfleger',
  [RelationshipTypeEnum.ENTITIES_EXECUTOR_OF_THE_WILL]: 'Testamentsvollstrecker',
  [RelationshipTypeEnum.ENTITIES_ESTATE_ADMINISTRATOR]: 'Nachlassverwalter',
  [RelationshipTypeEnum.ENTITIES_COMPULSORY_PORTION_BENEFICIARY]: 'Pflichtteilsberechtigter',
  [RelationshipTypeEnum.ENTITIES_SECONDARY_CLIENT]: 'Sekundärer Mandant',
  [RelationshipTypeEnum.ENTITIES_SECONDARY_OPPONENT]: 'Sekundärer Gegner',
  [RelationshipTypeEnum.ENTITIES_COURT_COMPLAINT]: 'Gerichtsbeschwerde',
  [RelationshipTypeEnum.ENTITIES_FINE_AUTHORITY]: 'Bußgeldbehörde',
  [RelationshipTypeEnum.ENTITIES_RESIDENT_REGISTRATION_OFFICE]: 'Einwohnermeldeamt',
  [RelationshipTypeEnum.ENTITIES_INVESTIGATOR]: 'Ermittler',
  [RelationshipTypeEnum.ENTITIES_BAILIFF]: 'Gerichtsvollzieher',
  [RelationshipTypeEnum.ENTITIES_INSOLVENCY_COURT]: 'Insolvenzgericht',
  [RelationshipTypeEnum.ENTITIES_INTEGRATION_OFFICE]: 'Integrationsamt',
  [RelationshipTypeEnum.ENTITIES_EXECUTION_ORGAN]: 'Vollstreckungsorgan',
  [RelationshipTypeEnum.ENTITIES_COMPULSORY_PORTION_BENEFICIARY]: 'Pflichtteilsberechtigter',
  [RelationshipTypeEnum.ENTITIES_NOTARY]: 'Notar',
  [RelationshipTypeEnum.ENTITIES_TRUSTEE]: 'Treuhänder',
  [RelationshipTypeEnum.ENTITIES_INSOLVENCY_ADMINISTRATOR]: 'Insolvenzverwalter',
  [RelationshipTypeEnum.ENTITIES_DEFENDANT_REPRESENTATIVE]: 'Beklagtenvertreter',
  [RelationshipTypeEnum.ENTITIES_PLAINTIFF_REPRESENTATIVE]: 'Klägervertreter',
  [RelationshipTypeEnum.ENTITIES_COMMUNITY_OF_HOMEOWNERS]:
    'Gemeinschaft der Wohnungseigentümer (GdWE)',
  [RelationshipTypeEnum.ENTITIES_FRACTIONAL_OWNER]: 'Bruchteilseigentümer',
  [RelationshipTypeEnum.ENTITIES_JOINT_DEBTOR]: 'Gesamtschuldner',
  [RelationshipTypeEnum.ENTITIES_JOINT_CREDITOR]: 'Gesamtgläubiger',
  [RelationshipTypeEnum.ENTITIES_APPLICATION_RESPONDENT]: 'Antragsgegner',
  [RelationshipTypeEnum.ENTITIES_HEREDITARY_BUILDING_GRANTOR]: 'Erbbaugeber',
  [RelationshipTypeEnum.ENTITIES_PROFESSIONAL_LIABILITY_INSURANCE]: 'Berufshaftpflichtversicherung',
  [RelationshipTypeEnum.ENTITIES_BUILDING_OWNERS_ASSOCIATION]: 'Bauherrengemeinschaft',
  [RelationshipTypeEnum.ENTITIES_LANDLORD_ASSOCIATION]: 'Vermieterverein',
  [RelationshipTypeEnum.ENTITIES_LANDLORD_COMMUNITY]: 'Vermietergemeinschaft',
  [RelationshipTypeEnum.ENTITIES_SPECIAL_PROPERTY_MANAGER]: 'Sondereigentumsverwalter',
  [RelationshipTypeEnum.ENTITIES_HOUSE_MANAGER]: 'Hausverwalter',
  [RelationshipTypeEnum.ENTITIES_APPELLANT]: 'Berufungskläger',
  [RelationshipTypeEnum.ENTITIES_APPELLEE]: 'Berufungsbeklagter',
  [RelationshipTypeEnum.ENTITIES_COUNTER_CLAIMANT]: 'Widerkläger',
  [RelationshipTypeEnum.ENTITIES_COUNTER_DEFENDANT]: 'Widerbeklagter',
  [RelationshipTypeEnum.ENTITIES_DOCTOR]: 'Arzt',
  [RelationshipTypeEnum.ENTITIES_LEGAL_GUARDIAN]: 'Sorgeberechtigter',
  [RelationshipTypeEnum.ENTITIES_GUARDIAN]: 'Vormund',
  [RelationshipTypeEnum.ENTITIES_CARETAKER]: 'Betreuer',
  [RelationshipTypeEnum.ENTITIES_YOUTH_WELFARE_OFFICE]: 'Jugendamt',
  [RelationshipTypeEnum.ENTITIES_FOSTER_PARENT]: 'Pflegeperson',
  [RelationshipTypeEnum.ENTITIES_PARENT]: 'Elternteil',
  [RelationshipTypeEnum.ENTITIES_MAINTENANCE_OBLIGOR]: 'Unterhaltspflichtiger',
  [RelationshipTypeEnum.ENTITIES_BENEFICIARY]: 'Leistungsberechtigter',
  [RelationshipTypeEnum.ENTITIES_ADMINISTRATIVE_ASSISTANT]: 'Verwaltungshelfer',
  [RelationshipTypeEnum.ENTITIES_CASE_WORKER]: 'Sachbearbeiter',
  [RelationshipTypeEnum.ENTITIES_MANAGING_DIRECTOR]: 'Geschäftsführer',
  [RelationshipTypeEnum.ENTITIES_SHAREHOLDER]: 'Gesellschafter',
  [RelationshipTypeEnum.ENTITIES_SUPERVISORY_BOARD]: 'Aufsichtsrat',
  [RelationshipTypeEnum.ENTITIES_COMMERCIAL_AGENT]: 'Handelsvertreter',
  [RelationshipTypeEnum.ENTITIES_LIMITED_PARTNER]: 'Kommanditist',
  [RelationshipTypeEnum.ENTITIES_AUTHORIZED_SIGNATORY]: 'Prokurist',
  [RelationshipTypeEnum.ENTITIES_SOCIAL_SECURITY_OFFICE]: 'Sozialamt',
  [RelationshipTypeEnum.ENTITIES_EMPLOYMENT_AGENCY]: 'Arbeitsagentur',
  [RelationshipTypeEnum.ENTITIES_JOB_CENTER]: 'Jobcenter',
  [RelationshipTypeEnum.ENTITIES_PENSION_INSURANCE]: 'Rentenversicherung',
  [RelationshipTypeEnum.ENTITIES_HEALTH_INSURANCE]: 'Krankenkasse',
  [RelationshipTypeEnum.ENTITIES_DISABILITY_OFFICE]: 'Versorgungsamt',
  [RelationshipTypeEnum.ENTITIES_SOCIAL_COURT]: 'Sozialgericht',
  [RelationshipTypeEnum.ENTITIES_MEDICAL_SERVICE]: 'Medizinischer Dienst',
  [RelationshipTypeEnum.ENTITIES_REHABILITATION_PROVIDER]: 'Rehabilitationsträger',
  [RelationshipTypeEnum.ENTITIES_PATIENT]: 'Patient',
  [RelationshipTypeEnum.ENTITIES_MEDICAL_INSTITUTION]: 'Medizinische Einrichtung',
  [RelationshipTypeEnum.ENTITIES_LEGAL_ASSISTANT]: 'Verfahrensbeistand',
  [RelationshipTypeEnum.ENTITIES_TAX_AUTHORITY]: 'Finanzbehörde',
  [RelationshipTypeEnum.ENTITIES_AFFECTED_PERSON]: 'Betroffener',
  [RelationshipTypeEnum.ENTITIES_OPPONENT_INSURANCE]: 'Gegnerische Versicherung',
  [RelationshipTypeEnum.ENTITIES_WORKSHOP]: 'Werkstatt',
  [RelationshipTypeEnum.ENTITIES_JOINT_PLAINTIFF]: 'Mitkläger',
  [RelationshipTypeEnum.ENTITIES_POLICYHOLDER]: 'Versicherungsnehmer',
  [RelationshipTypeEnum.ENTITIES_GUARANTOR_CREDITOR]: 'Bürgschaftsgläubiger'
}

export const entitiesEN = {
  [RelationshipTypeEnum.ENTITIES_CLIENT]: 'Client',
  [RelationshipTypeEnum.ENTITIES_OPPONENT]: 'Opponent',
  [RelationshipTypeEnum.ENTITIES_OTHER]: 'Other',
  [RelationshipTypeEnum.ENTITIES_LABOR_LAW_EMPLOYEE]: 'Employee',
  [RelationshipTypeEnum.ENTITIES_LABOR_LAW_EMPLOYER]: 'Employer',
  [RelationshipTypeEnum.ENTITIES_WITNESS]: 'Witness',
  [RelationshipTypeEnum.ENTITIES_AT_FAULT_DRIVER]: 'At Fault Driver',
  [RelationshipTypeEnum.ENTITIES_VICTIM_DRIVER]: 'Victim Driver',
  [RelationshipTypeEnum.ENTITIES_ACCUSED]: 'Accused',
  [RelationshipTypeEnum.ENTITIES_DEFENDANT]: 'Defendant',
  [RelationshipTypeEnum.ENTITIES_COMPLAINT]: 'Complaint',
  [RelationshipTypeEnum.ENTITIES_PLAINTIFF]: 'Plaintiff',
  [RelationshipTypeEnum.ENTITIES_VICTIM]: 'Victim',
  [RelationshipTypeEnum.ENTITIES_VEHICLE_EXPERT]: 'Vehicle Expert',
  [RelationshipTypeEnum.ENTITIES_AGENCY]: 'Agency',
  [RelationshipTypeEnum.ENTITIES_FOREIGNERS_AUTHORITY]: 'Foreigners Authority',
  [RelationshipTypeEnum.ENTITIES_VEHICLE_OWNER]: 'Vehicle Owner',
  [RelationshipTypeEnum.ENTITIES_INSURANCE]: 'Insurance',
  [RelationshipTypeEnum.ENTITIES_DRIVER]: 'Driver',
  [RelationshipTypeEnum.ENTITIES_POLICE_OFFICER]: 'Police Officer',
  [RelationshipTypeEnum.ENTITIES_POLICE_STATION]: 'Police Station',
  [RelationshipTypeEnum.ENTITIES_JUDGE]: 'Judge',
  [RelationshipTypeEnum.ENTITIES_COURT]: 'Court',
  [RelationshipTypeEnum.ENTITIES_PROSECUTOR]: 'Prosecutor',
  [RelationshipTypeEnum.ENTITIES_PUBLIC_PROSECUTOR]: 'Public Prosecutor',
  [RelationshipTypeEnum.ENTITIES_OPPOSING_COUNSEL]: 'Opposing Counsel',
  [RelationshipTypeEnum.ENTITIES_LAWYER]: 'Lawyer',
  [RelationshipTypeEnum.ENTITIES_CO_PLAINTIFF]: 'Co-Plaintiff',
  [RelationshipTypeEnum.ENTITIES_PROBATION_OFFICER]: 'Probation Officer',
  [RelationshipTypeEnum.ENTITIES_TENANT]: 'Tenant',
  [RelationshipTypeEnum.ENTITIES_LANDLORD]: 'Landlord',
  [RelationshipTypeEnum.ENTITIES_SUBTENANT]: 'Subtenant',
  [RelationshipTypeEnum.ENTITIES_OWNER]: 'Owner',
  [RelationshipTypeEnum.ENTITIES_PROPERTY_MANAGEMENT]: 'Property Management',
  [RelationshipTypeEnum.ENTITIES_REAL_ESTATE_AGENT]: 'Real Estate Agent',
  [RelationshipTypeEnum.ENTITIES_GUARANTOR]: 'Guarantor',
  [RelationshipTypeEnum.ENTITIES_CO_OWNER]: 'Co-Owner',
  [RelationshipTypeEnum.ENTITIES_CO_TENANT]: 'Co-Tenant',
  [RelationshipTypeEnum.ENTITIES_TENANTS_ASSOCIATION]: 'Tenants Association',
  [RelationshipTypeEnum.ENTITIES_PROPERTY_OWNERS_ASSOCIATION]: 'Property Owners Association',
  [RelationshipTypeEnum.ENTITIES_COMPLAINANT]: 'Complainant',
  [RelationshipTypeEnum.ENTITIES_APPLICANT]: 'Applicant',
  [RelationshipTypeEnum.ENTITIES_RESPONDENT]: 'Respondent',
  [RelationshipTypeEnum.ENTITIES_PRINCIPAL_CLIENT]: 'Principal Client',
  [RelationshipTypeEnum.ENTITIES_CHILD]: 'Child',
  [RelationshipTypeEnum.ENTITIES_OFFICIANT]: 'Officiant',
  [RelationshipTypeEnum.ENTITIES_WIFE]: 'Wife',
  [RelationshipTypeEnum.ENTITIES_HUSBAND]: 'Husband',
  [RelationshipTypeEnum.ENTITIES_LEGAL_REPRESENTATIVE]: 'Legal Representative',
  [RelationshipTypeEnum.ENTITIES_KORRESPONDENCE_LAWYER]: 'Correspondence Lawyer',
  [RelationshipTypeEnum.ENTITIES_OPPOSING_LAWYER]: 'Opposing Lawyer',
  [RelationshipTypeEnum.ENTITIES_LEGAL_EXPENSES_INSURANCE]: 'Legal Expenses Insurance',
  [RelationshipTypeEnum.ENTITIES_LIABILITY_INSURANCE]: 'Liability Insurance',
  [RelationshipTypeEnum.ENTITIES_FIRST_INSTANCE_COURT]: 'First Instance Court',
  [RelationshipTypeEnum.ENTITIES_SECOND_INSTANCE_COURT]: 'Second Instance Court',
  [RelationshipTypeEnum.ENTITIES_THIRD_INSTANCE_COURT]: 'Third Instance Court',
  [RelationshipTypeEnum.ENTITIES_CONTACT_PERSON]: 'Contact Person',
  [RelationshipTypeEnum.ENTITIES_THIRD_PARTY_DEBTOR]: 'Third Party Debtor',
  [RelationshipTypeEnum.ENTITIES_ROAD_TRAFFIC_OFFICE]: 'Road Traffic Office',
  [RelationshipTypeEnum.ENTITIES_DEBT_COLLECTION_AGENCY]: 'Debt Collection Agency',
  [RelationshipTypeEnum.ENTITIES_EXPERT]: 'Expert',
  [RelationshipTypeEnum.ENTITIES_TAX_OFFICE]: 'Tax Office',
  [RelationshipTypeEnum.ENTITIES_LAND_REGISTRY]: 'Land Registry',
  [RelationshipTypeEnum.ENTITIES_BANK]: 'Bank',
  [RelationshipTypeEnum.ENTITIES_BUYER]: 'Buyer',
  [RelationshipTypeEnum.ENTITIES_DUNNING_COURT]: 'Dunning Court',
  [RelationshipTypeEnum.ENTITIES_ENFORCEMENT_COURT]: 'Enforcement Court',
  [RelationshipTypeEnum.ENTITIES_GENERAL_PROSECUTOR]: 'General Prosecutor',
  [RelationshipTypeEnum.ENTITIES_SELLER]: 'Seller',
  [RelationshipTypeEnum.ENTITIES_EXPERT_COMMITTEE]: 'Expert Committee',
  [RelationshipTypeEnum.ENTITIES_MUNICIPALITY]: 'Municipality',
  [RelationshipTypeEnum.ENTITIES_ADMINISTRATOR]: 'Administrator',
  [RelationshipTypeEnum.ENTITIES_REGISTER_COURT]: 'Register Court',
  [RelationshipTypeEnum.ENTITIES_PROBATE_COURT]: 'Probate Court',
  [RelationshipTypeEnum.ENTITIES_REGISTRY_OFFICE]: 'Registry Office',
  [RelationshipTypeEnum.ENTITIES_HEREDITARY_LEASEHOLDER]: 'Hereditary Leaseholder',
  [RelationshipTypeEnum.ENTITIES_LEGAL_AID_COURT]: 'Legal Aid Court',
  [RelationshipTypeEnum.ENTITIES_DEBTOR]: 'Debtor',
  [RelationshipTypeEnum.ENTITIES_CREDITOR]: 'Creditor',
  [RelationshipTypeEnum.ENTITIES_LESSEE]: 'Lessee',
  [RelationshipTypeEnum.ENTITIES_LESSOR]: 'Lessor',
  [RelationshipTypeEnum.ENTITIES_PRINCIPAL]: 'Principal',
  [RelationshipTypeEnum.ENTITIES_AUTHORIZED_REPRESENTATIVE]: 'Authorized Representative',
  [RelationshipTypeEnum.ENTITIES_TESTATOR]: 'Testator',
  [RelationshipTypeEnum.ENTITIES_HEIR]: 'Heir',
  [RelationshipTypeEnum.ENTITIES_PRELIMINARY_HEIR]: 'Preliminary Heir',
  [RelationshipTypeEnum.ENTITIES_SUBSEQUENT_HEIR]: 'Subsequent Heir',
  [RelationshipTypeEnum.ENTITIES_CURATOR_OF_THE_ESTATE]: 'Curator of the Estate',
  [RelationshipTypeEnum.ENTITIES_EXECUTOR_OF_THE_WILL]: 'Executor of the Will',
  [RelationshipTypeEnum.ENTITIES_ESTATE_ADMINISTRATOR]: 'Estate Administrator',
  [RelationshipTypeEnum.ENTITIES_COMPULSORY_PORTION_BENEFICIARY]: 'Compulsory Portion Beneficiary',
  [RelationshipTypeEnum.ENTITIES_SECONDARY_CLIENT]: 'Secondary Client',
  [RelationshipTypeEnum.ENTITIES_SECONDARY_OPPONENT]: 'Secondary Opponent',
  [RelationshipTypeEnum.ENTITIES_COURT_COMPLAINT]: 'Court Complaint',
  [RelationshipTypeEnum.ENTITIES_FINE_AUTHORITY]: 'Fine Authority',
  [RelationshipTypeEnum.ENTITIES_RESIDENT_REGISTRATION_OFFICE]: 'Resident Registration Office',
  [RelationshipTypeEnum.ENTITIES_INVESTIGATOR]: 'Investigator',
  [RelationshipTypeEnum.ENTITIES_BAILIFF]: 'Bailiff',
  [RelationshipTypeEnum.ENTITIES_INSOLVENCY_COURT]: 'Insolvency Court',
  [RelationshipTypeEnum.ENTITIES_INTEGRATION_OFFICE]: 'Integration Office',
  [RelationshipTypeEnum.ENTITIES_EXECUTION_ORGAN]: 'Execution Organ',
  [RelationshipTypeEnum.ENTITIES_COMPULSORY_PORTION_BENEFICIARY]: 'Compulsory Portion Beneficiary',
  [RelationshipTypeEnum.ENTITIES_NOTARY]: 'Notary',
  [RelationshipTypeEnum.ENTITIES_TRUSTEE]: 'Trustee',
  [RelationshipTypeEnum.ENTITIES_INSOLVENCY_ADMINISTRATOR]: 'Insolvency Administrator',
  [RelationshipTypeEnum.ENTITIES_DEFENDANT_REPRESENTATIVE]: 'Defendant Representative',
  [RelationshipTypeEnum.ENTITIES_PLAINTIFF_REPRESENTATIVE]: 'Plaintiff Representative',
  [RelationshipTypeEnum.ENTITIES_COMMUNITY_OF_HOMEOWNERS]: 'Community of Homeowners',
  [RelationshipTypeEnum.ENTITIES_FRACTIONAL_OWNER]: 'Fractional Owner',
  [RelationshipTypeEnum.ENTITIES_JOINT_DEBTOR]: 'Joint Debtor',
  [RelationshipTypeEnum.ENTITIES_JOINT_CREDITOR]: 'Joint Creditor',
  [RelationshipTypeEnum.ENTITIES_APPLICATION_RESPONDENT]: 'Application Respondent',
  [RelationshipTypeEnum.ENTITIES_HEREDITARY_BUILDING_GRANTOR]: 'Hereditary Building Grantor',
  [RelationshipTypeEnum.ENTITIES_PROFESSIONAL_LIABILITY_INSURANCE]:
    'Professional Liability Insurance',
  [RelationshipTypeEnum.ENTITIES_BUILDING_OWNERS_ASSOCIATION]: 'Building Owners Association',
  [RelationshipTypeEnum.ENTITIES_LANDLORD_ASSOCIATION]: 'Landlord Association',
  [RelationshipTypeEnum.ENTITIES_LANDLORD_COMMUNITY]: 'Landlord Community',
  [RelationshipTypeEnum.ENTITIES_SPECIAL_PROPERTY_MANAGER]: 'Special Property Manager',
  [RelationshipTypeEnum.ENTITIES_HOUSE_MANAGER]: 'House Manager',
  [RelationshipTypeEnum.ENTITIES_APPELLANT]: 'Appellant',
  [RelationshipTypeEnum.ENTITIES_APPELLEE]: 'Appellee',
  [RelationshipTypeEnum.ENTITIES_COUNTER_CLAIMANT]: 'Counter Claimant',
  [RelationshipTypeEnum.ENTITIES_COUNTER_DEFENDANT]: 'Counter Defendant',
  [RelationshipTypeEnum.ENTITIES_DOCTOR]: 'Doctor',
  [RelationshipTypeEnum.ENTITIES_LEGAL_GUARDIAN]: 'Legal Guardian',
  [RelationshipTypeEnum.ENTITIES_GUARDIAN]: 'Guardian',
  [RelationshipTypeEnum.ENTITIES_CARETAKER]: 'Caretaker',
  [RelationshipTypeEnum.ENTITIES_YOUTH_WELFARE_OFFICE]: 'Youth Welfare Office',
  [RelationshipTypeEnum.ENTITIES_FOSTER_PARENT]: 'Foster Parent',
  [RelationshipTypeEnum.ENTITIES_PARENT]: 'Parent',
  [RelationshipTypeEnum.ENTITIES_MAINTENANCE_OBLIGOR]: 'Maintenance Obligor',
  [RelationshipTypeEnum.ENTITIES_BENEFICIARY]: 'Beneficiary',
  [RelationshipTypeEnum.ENTITIES_ADMINISTRATIVE_ASSISTANT]: 'Administrative Assistant',
  [RelationshipTypeEnum.ENTITIES_CASE_WORKER]: 'Case Worker',
  [RelationshipTypeEnum.ENTITIES_MANAGING_DIRECTOR]: 'Managing Director',
  [RelationshipTypeEnum.ENTITIES_SHAREHOLDER]: 'Shareholder',
  [RelationshipTypeEnum.ENTITIES_SUPERVISORY_BOARD]: 'Supervisory Board',
  [RelationshipTypeEnum.ENTITIES_COMMERCIAL_AGENT]: 'Commercial Agent',
  [RelationshipTypeEnum.ENTITIES_LIMITED_PARTNER]: 'Limited Partner',
  [RelationshipTypeEnum.ENTITIES_AUTHORIZED_SIGNATORY]: 'Authorized Signatory',
  [RelationshipTypeEnum.ENTITIES_SOCIAL_SECURITY_OFFICE]: 'Social Security Office',
  [RelationshipTypeEnum.ENTITIES_EMPLOYMENT_AGENCY]: 'Employment Agency',
  [RelationshipTypeEnum.ENTITIES_JOB_CENTER]: 'Job Center',
  [RelationshipTypeEnum.ENTITIES_PENSION_INSURANCE]: 'Pension Insurance',
  [RelationshipTypeEnum.ENTITIES_HEALTH_INSURANCE]: 'Health Insurance',
  [RelationshipTypeEnum.ENTITIES_DISABILITY_OFFICE]: 'Disability Office',
  [RelationshipTypeEnum.ENTITIES_SOCIAL_COURT]: 'Social Court',
  [RelationshipTypeEnum.ENTITIES_MEDICAL_SERVICE]: 'Medical Service',
  [RelationshipTypeEnum.ENTITIES_REHABILITATION_PROVIDER]: 'Rehabilitation Provider',
  [RelationshipTypeEnum.ENTITIES_PATIENT]: 'Patient',
  [RelationshipTypeEnum.ENTITIES_MEDICAL_INSTITUTION]: 'Medical Institution',
  [RelationshipTypeEnum.ENTITIES_LEGAL_ASSISTANT]: 'Legal Assistant',
  [RelationshipTypeEnum.ENTITIES_TAX_AUTHORITY]: 'Tax Authority',
  [RelationshipTypeEnum.ENTITIES_AFFECTED_PERSON]: 'Affected Person',
  [RelationshipTypeEnum.ENTITIES_OPPONENT_INSURANCE]: 'Opponent Insurance',
  [RelationshipTypeEnum.ENTITIES_WORKSHOP]: 'Workshop',
  [RelationshipTypeEnum.ENTITIES_JOINT_PLAINTIFF]: 'Joint Plaintiff',
  [RelationshipTypeEnum.ENTITIES_POLICYHOLDER]: 'Policyholder',
  [RelationshipTypeEnum.ENTITIES_GUARANTOR_CREDITOR]: 'Guarantor Creditor'
}
